module.exports = __webpack_public_path__ + "img/ground_choose_yes.83a94dfe.svg";